import React, { useEffect, useState } from "react";
import styles from "./index.modules.less";
import classNames from "classnames";
import { canVisitModule } from "../../utils/permission";

const itemList = ({ setOpen, identityType, permissionCodes }) => {
  const isSubAccount = identityType === "sub_account";
  const hasComplaint = canVisitModule({ identityType, permissionCodes, requiredPermission: "complaint_handling" });

  const data = [
    {
      title: "添加软件 >",
      desc: "添加到软件管家",
      cn: "addSoft",
      image: "https://p0.ssl.qhimg.com/t018f6e37e0f593edc7.png",
      visible: true,
      click: () => {
        setOpen(true);
      },
    },
    {
      title: "数据服务 >",
      desc: "查询流水、结算",
      cn: "dataService",
      image: "https://p5.ssl.qhimg.com/t01a8b0c5ed115bba55.png",
      visible: !isSubAccount,
      click: () => {
        window.open("https://ssp.360.cn/smunion/revenue/overview");
      },
    },
    {
      title: "文档中心 >",
      desc: "接入文档、帮助",
      cn: "help",
      image: "https://p0.ssl.qhimg.com/t01e9cc89e9bd06093c.png",
      visible: !isSubAccount,
      click: () => {
        window.open("https://soft.360.cn/cms/lyptwdzx.html?doc=member-sdk", "_blank", "noopener,noreferrer");
      },
    },
    {
      title: "用户投诉 >",
      desc: "回复用户、退款",
      cn: "complaints",
      image: "https://p5.ssl.qhimg.com/t11b673bcd60ccdc047e429acba.png",
      visible: !isSubAccount || hasComplaint,
      click: () => {
        window.open("/view/complaint_center")
      },
    },
  ];

  return data
    .filter((item) => item.visible)
    .map((item, index) => {
    return (
      <div
        onClick={item.click}
        className={classNames(styles.item, {
          [styles.dataService]: item.cn === "dataService",
          [styles.help]: item.cn === "help",
          [styles.complaints]: item.cn === "complaints",
        })}
        key={index}
      >
        <div className={styles.itemTitleContent}>
          <span className={styles.itemTitle}>{item.title}</span>
          <span className={styles.itemDesc}>{item.desc}</span>
        </div>
        <div className={styles.icon} alt="">
          <div className={styles.image}>
            <img className={styles.img} src={item.image} />
          </div>
        </div>
      </div>
    );
  });
};
const Service = ({ setOpen, identityType, permissionCodes }) => {
  const [isShowAnnouncement, updateIsShowAnnouncement] = useState(false)
  useEffect(() => {
    const endDate = new Date('2025/02/05')
    const now = new Date()
    updateIsShowAnnouncement(now < endDate)
  }, [])

  return (
    <div className={styles.wrapper}>
      <div className={styles.titleWrapper}>
        <h1 className={styles.title}>联运服务</h1>
        {isShowAnnouncement && <div className={styles.announcement}>尊敬的合作厂商，您好，软件管家将于春节假期期间（01月28日至02月04日）暂停联运软件收录审核，感谢您的支持与理解~，祝您新春快乐！</div>}
      </div>
      <div className={styles.content}>{itemList({ setOpen, identityType, permissionCodes })}</div>
    </div>
  );
};
export default Service;
